import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { approveResultV2 } from 'services/results/v2'
import type { ApproveResultV2Params, ApproveResultV2Response } from 'services/results/v2/types'
import type { ApiErrorResponse } from 'services/types'

/** mutation-cache: synced by the callers (useResults, ExportAndAccessRequestsTable onSuccess): result details / verification list and activity queries */
export const useApproveResultV2 = (
  options?: UseMutationOptions<
    ApproveResultV2Response,
    ApiErrorResponse,
    { resultId: string; params: ApproveResultV2Params }
  >
) => {
  return useMutation<ApproveResultV2Response, ApiErrorResponse, { resultId: string; params: ApproveResultV2Params }>({
    mutationFn: args => approveResultV2(args.resultId, args.params),
    ...options
  })
}
